import { z } from 'zod';
import { IsoDateTimeSchema, withMeta } from '../common';
import { ScorePillarSchema } from '../dataset/core';
import { defineProcedures, query, type RouterShape } from '../procedure';
import { defineFamily } from './family';

/** public.* — kernel router, no auth: the public score card at p5.{domain}/card/{token} (SDD §7.4).
 *  Verified figures only; revoked-token state; noindex; view counter. */

export const PublicCardSchema = withMeta({
  state: z.enum(['active', 'revoked']),
  /** null when revoked. */
  card: z
    .object({
      name: z.string(),
      slug: z.string(),
      score: z.number(),
      tier: z.string(),
      verified: z.literal(true),
      /** Pillars are present only for verified viewers; ungated viewers get the headline. */
      pillars: z.array(ScorePillarSchema).nullable(),
      asOf: IsoDateTimeSchema,
    })
    .strict()
    .nullable(),
  views: z.number().int(),
  noindex: z.literal(true),
});
export type PublicCard = z.infer<typeof PublicCardSchema>;

export const publicProcedures = defineProcedures({
  'public.card.get': query(
    'Public score card by revocable token (counts the view)',
    z.object({ token: z.string().min(8).max(128) }).strict(),
    PublicCardSchema,
  ),
});
export type PublicFamilyClient = RouterShape<typeof publicProcedures>;

export const publicFamily = defineFamily({
  name: 'public',
  title: 'Public score card',
  screens: ['Public score card'],
  procedures: publicProcedures,
  binding: 'simulated',
});
